/* SKINGRAPHICA redesign, polish layer scripts. Generated */
/* pull statements: each sentence on its own line, so a two-sentence statement reads as a couplet */
(function () {
  'use strict';
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg-aq blockquote:not([data-sg-aq])'), function (q) {
      q.setAttribute('data-sg-aq', '1');
      if (q.children.length) return;
      var parts = q.textContent.trim().match(/[^.!?]+[.!?]+(\s|$)/g);
      if (!parts || parts.length < 2 || parts.length > 3) return;
      q.textContent = '';
      parts.forEach(function (s) { var sp = document.createElement('span'); sp.className = 'pg-aq-s'; sp.textContent = s.trim(); q.appendChild(sp); q.appendChild(document.createTextNode(' ')); });
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
/* images that carry type (wordmarks, typographic headers) are never cropped inside tiles and cards: they show whole, on a ground that matches the artwork */
(function () {
  'use strict';
  var GROUNDS = [[/SG_TypeHeader/i, '#161210'], [/SG_Graphica/i, '#0d0d0d'], [/SG_Status/i, '#e4e4e4'], [/Novica/i, '#ffffff']];
  function ground(src) { for (var i = 0; i < GROUNDS.length; i++) { if (GROUNDS[i][0].test(src)) return GROUNDS[i][1]; } return ''; }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg-tile-i img, .pgv .pg-fig img, .sgq-c .q-card-i img'), function (im) {
      var g = ground(im.getAttribute('src') || '');
      if (!g || /SG_TypeHeader_Fails/i.test(im.getAttribute('src') || '')) return; /* FAILS sits well inside any tile crop, so it fills its tile (Mat, 26 Oct) */
      var box = im.parentElement;
      box.classList.add('sg-graphic');
      box.style.backgroundColor = g;
    });
    /* page openings with type artwork: on narrower screens the artwork shows whole above the words, on its own ground */
    Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg-hero .pg-hero-m img'), function (im) {
      var g = ground(im.getAttribute('src') || '');
      if (!g) return;
      var h = im.closest('.pg-hero');
      h.classList.add('pg-hero--type');
      h.style.setProperty('--ground', g);
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
/* Continue exploring: every tile shows the place it leads to. Pages use their own opening image, the programmes and rankings use their own wordmark on their own ground */
(function () {
  'use strict';
  var IMG = {"our-story":"skingraphica-our-story-tattoo-chair-portrait.jpg","our-difference":"skingraphica-gel-drop-sandstone.webp","our-lab":"skingraphica-lab-cream-pour.webp","our-secret":"skingraphica-emulsion-test-tubes.webp","our-science":"SG_Science.jpg","ink-safe-promise":"skingraphica-ink-safe-gel-and-pigment.webp","stage-targeted-science":"skingraphica-amber-vial-dark-lab.webp","ai-advantage":"skingraphica-droplet-over-black-liquid.webp","quality-guarantee":"skingraphica-texture-cream.webp","hall-of-fame-overview":"Steve_Butcher_Bird.jpg","hall-of-fame-2026-inductees":"skingraphica-hall-of-fame-gallery.jpg","the-guide":"skingraphica-tattoo-care-guide-card.jpg","care-by-stage":"skingraphica-care-by-stage-card.jpg","top-10-mistakes":"SG_TypeHeader_Fails.jpg","mistakes-by-stage":"SG_TypeHeader_Fails.jpg","top-10-myths":"SG_TypeHeader_Busted_8cd0630e-df28-4a46-94d7-94e0fa176d04.jpg","our-advantage":"Steve-Lounge.jpg","made-for-masters":"marco-cover-wide.webp","tattoo-history":"SG_History.jpg","tattoo-styles":"SG_History_Styles.jpg","legendary-artists":"SG_History_Artists.jpg","tattoo-culture":"SG_History_Culture.jpg","tattoo-milestones":"SG_History_Milestones.jpg","how-tattooing-works":"skingraphica-how-tattooing-works.jpg","how-inked-skin-is-different":"skingraphica-how-inked-skin-is-different.jpg","what-nobody-tells-you":"skingraphica-torn-paper-ink-layer.jpg","courses":"Screenshot_2025-09-18_at_9.31.16_pm.png","concierge-service":"skingraphica-stylist-concierge-card.jpg","faqs":"skingraphica-tattoo-care-faqs.jpg","artists-studios":"brent-mccown-rainforest-desktop.webp","retailers":"skingraphica-hand-beaten-copper.jpg","proudly-australian":"skingraphica-whitsundays-silica-sand.webp","be-skin-smart":"skingraphica-be-skin-smart-sun.jpg","definitive-guide":"skingraphica-definitive-care-guide-card.jpg","global-hq":"155KingSt.jpg","product-information":"skingraphica-black-ink-splash.webp","tattoos-and-the-law":"skingraphica-tattoos-and-the-law.jpg","why-were-more-expensive":"skingraphica-built-to-last-limestone.jpg","our-purpose":"pittakkm-shoot-04-gloves-watch.jpg","contact":"skingraphica-concierge-contact-card.jpg","claims-compliance":"skingraphica-cream-pearl-drop.webp","signature-studio-program":"skingraphica-signature-studio-setup.jpg","studio-partner-program":"skingraphica-studio-partner-tattoo-studio.jpg"};
  var BASE = ((document.currentScript && document.currentScript.src) || '').replace(/sg-rd-x\.js.*$/, '');
  var PLATE = {
    'worlds-top-10-artists': ['#0b0b0b', 'a:Black_Ivy_W.svg', 0],
    'worlds-top-100-artists': ['#ecebe8', 'a:Graphica_B.svg', 1],
    'graphica-membership': ['#ecebe8', 'a:Graphica_B.svg', 1],
    'im-a-ranked-artist': ['#ecebe8', 'a:Graphica_B.svg', 1],
    'rankings-criteria': ['#0b0b0b', 'a:SG_Monogram_Detailed_Emboss-1300.png', 0, 1],
    'global-rising-20': ['#e6e6e6', '20-rising-nova.svg', 1],
    'status-program': ['#2a1a12', 'Status_W_4eddc4c3-685c-45ae-840e-8e150e142b13.svg', 0],
    'courses': ['#2a1a12', 'a:SG_Monogram_Detailed_Emboss-1300.png', 0, 1]
  };
  function src(f, w) { if (f.indexOf('a:') === 0) return BASE + f.slice(2) + '?v=20261025'; return '/cdn/shop/files/' + f + (/\.svg$/i.test(f) ? '' : '?width=' + w); }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg'), function (pg) {
      var lb = pg.querySelector('.pg-head .lbl');
      if (!pg.querySelector('.pg-tiles .pg-tile--a') || !(/continue exploring/i.test(lb ? lb.textContent : '') || /sg_page_related$/.test((pg.closest('.shopify-section') || {}).id || ''))) return;
      pg.classList.add('sg-rel');
      Array.prototype.forEach.call(pg.querySelectorAll('.pg-tile'), function (t) {
        var a = t.querySelector('.pg-tt a'); if (!a) return;
        var h = (a.getAttribute('href') || '').replace(/^.*\/pages\//, '').replace(/[?#].*$/, '');
        var box = t.querySelector('.pg-tile-i'); if (!box) return;
        var p = PLATE[h];
        if (p) {
          box.innerHTML = '<span class="sg-plate' + (p[3] ? ' sg-plate--fill' : '') + '" style="background:' + p[0] + '"><img src="' + src(p[1], 1100) + '" alt="" loading="lazy"></span>';
          t.classList.toggle('sg-rel--light', !!p[2]);
          return;
        }
        var f = IMG[h], im = box.querySelector('img');
        if (f && im && (im.getAttribute('src') || '').indexOf(f.split('.')[0]) < 0) {
          im.removeAttribute('srcset');
          im.setAttribute('src', src(f, 900));
          im.setAttribute('srcset', src(f, 500) + ' 500w, ' + src(f, 900) + ' 900w, ' + src(f, 1400) + ' 1400w, ' + src(f, 1600) + ' 1600w, ' + src(f, 2000) + ' 2000w');
        }
        /* a photograph always fills its tile edge to edge */
        if (im && !/SG_TypeHeader|SG_Graphica|SG_Status|Novica/i.test(im.getAttribute('src') || '')) { box.classList.remove('sg-graphic'); box.style.backgroundColor = ''; }
      });
    });
    /* any other tile that still carries an old typographic header for a programme or ranking gets the same clean plate: its wordmark on its own ground */
    Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg:not(.sg-rel) .pg-tile'), function (t) {
      var a = t.querySelector('.pg-tt a'), box = t.querySelector('.pg-tile-i'), im = box && box.querySelector('img');
      if (!a || !im || !/SG_TypeHeader|SG_Graphica|SG_Status|Novica/i.test(im.getAttribute('src') || '')) return;
      var p = PLATE[(a.getAttribute('href') || '').replace(/^.*\/pages\//, '').replace(/[?#].*$/, '')];
      if (!p) return;
      box.classList.remove('sg-graphic'); box.style.backgroundColor = '';
      box.innerHTML = '<span class="sg-plate' + (p[3] ? ' sg-plate--fill' : '') + '" style="background:' + p[0] + '"><img src="' + src(p[1], 1100) + '" alt="" loading="lazy"></span>';
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
/* process sections (an Application process, a How it works) read as a timeline: numbered nodes joined by a fine line */
(function () {
  'use strict';
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg'), function (pg) {
      var st = pg.querySelector('.pg-steps'), hd = pg.querySelector('.pg-head') || pg;
      var lb = hd.querySelector('.lbl'), h = hd.querySelector('h2');
      var t = (lb ? lb.textContent : '') + ' ' + (h ? h.textContent : '');
      if (!st || !/process|how it works|the journey|timeline|from application|application to/i.test(t)) return;
      pg.classList.add('sg-tl');
      st.style.setProperty('--n', st.children.length);
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
/* forms: country codes, saved address autofill and live ticks, loaded only where a form needs them */
(function () {
  'use strict';
  var me = document.currentScript;
  var BASE = ((me && me.src) || '').replace(/sg-rd-x\.js.*$/, '');
  /* the footer passes the versioned asset URL, so each upload reaches visitors straight away */
  var SRC = (me && me.getAttribute('data-sgform')) || (BASE + 'sg-rd-form.js');
  function go() {
    if (!BASE || window.__sgFormLoading) return;
    if (!document.querySelector('form input[type=tel], form input[type=email], form textarea, form [data-sgf-addr]')) return;
    window.__sgFormLoading = 1;
    var s = document.createElement('script'); s.src = SRC; s.defer = true; document.head.appendChild(s);
  }
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
})();
/* do and avoid: a point titled Do or Avoid shows as a card, its list marked with ticks or crosses, as in the care guide */
(function () {
  'use strict';
  var Y = /^(do|do this|keep doing|normal|good signs|what helps)$/i, N = /^(avoid|don’t|don't|never|see a doctor|stop and ask|what hurts)$/i;
  var TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>', CROSS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg>';
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg-row:not([data-sg-da])'), function (r) {
      r.setAttribute('data-sg-da', '1');
      var t = r.querySelector('.pg-row-t'); if (!t) return;
      var s = t.textContent.trim(), y = Y.test(s), n = !y && N.test(s);
      if (!y && !n) return;
      r.classList.add('sg-da', y ? 'sg-da--y' : 'sg-da--n');
      t.insertAdjacentHTML('afterbegin', '<span class="sg-da-i">' + (y ? TICK : CROSS) + '</span>');
      Array.prototype.forEach.call(r.querySelectorAll('.pg-tx li'), function (li) { li.insertAdjacentHTML('afterbegin', '<span class="sg-da-li">' + (y ? TICK : CROSS) + '</span>'); });
      if (r.parentNode) r.parentNode.classList.add('sg-da-g');
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
/* brand marks. SKINGRAPHICA carries ® in running copy (never in menus, navigation or footer links), Ink-Safe and Ink-Sights always carry ™, set small and raised. Visible text only, never titles, alt text, links or form fields */
(function () {
  'use strict';
  var RX = /(SKINGRAPHICA|Ink-Safe|Ink-Sights)([®™]?)/g, SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION|TITLE|SVG|CODE|PRE)$/;
  function mark(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      if (!/SKINGRAPHICA|Ink-S/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
      for (var p = n.parentNode; p && p !== root.parentNode; p = p.parentNode) { if (p.nodeType === 1 && (SKIP.test(p.nodeName.toUpperCase()) || p.classList.contains('sg-r') || p.hasAttribute('data-no-mark') || p.isContentEditable || p.nodeName === 'NAV' || p.id === 'sg-menu' || p.classList.contains('sg-hdr') || p.classList.contains('f-cols') || p.classList.contains('f-legal'))) return NodeFilter.FILTER_REJECT; }
      return NodeFilter.FILTER_ACCEPT; } });
    var list = []; while (w.nextNode()) list.push(w.currentNode);
    list.forEach(function (n) {
      var t = n.nodeValue, f = document.createDocumentFragment(), last = 0, m, hit = false;
      RX.lastIndex = 0;
      while ((m = RX.exec(t))) {
        if (!m[2] && m.index + m[0].length === t.length && n.nextSibling && /^[®™]/.test(n.nextSibling.textContent || '')) continue;
        hit = true;
        f.appendChild(document.createTextNode(t.slice(last, m.index) + m[1]));
        var s = document.createElement('span'); s.className = 'sg-r'; s.textContent = m[1] === 'SKINGRAPHICA' ? '®' : '™'; f.appendChild(s);
        last = m.index + m[0].length;
      }
      if (!hit) return;
      f.appendChild(document.createTextNode(t.slice(last)));
      n.parentNode.replaceChild(f, n);
    });
  }
  var q = false;
  function go() { mark(document.body); if (window.MutationObserver) new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; mark(document.body); }); }).observe(document.body, { childList: true, subtree: true, characterData: true }); }
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
})();
/* On this page: each chip uses its section's short label (Depth, Colour, Sources) when every section has one, so the index reads at a glance */
(function () {
  'use strict';
  function run() {
    var links = document.querySelectorAll('.pgv .pg-toc-l a[data-for]');
    if (!links.length) return;
    var names = [];
    for (var i = 0; i < links.length; i++) {
      var h = document.getElementById(links[i].getAttribute('data-for'));
      var box = h && (h.closest('.pg-head') || h.closest('.pg-text-h') || h.parentNode);
      var lb = box && box.querySelector('.lbl');
      var t = lb ? lb.textContent.trim() : '';
      if (!t || t.length > 28) return;
      names.push(t);
    }
    if (names.length !== new Set(names.map(function (n) { return n.toLowerCase(); })).size) return;
    for (var j = 0; j < links.length; j++) { links[j].setAttribute('title', links[j].textContent); links[j].textContent = names[j]; }
  }
  function later() { setTimeout(run, 0); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
})();
/* one tone rule for every page. Each eyebrow learns whether it sits on a light ground, an espresso ground or a photograph, and takes bronze, gold or stays light. On espresso, plain white running copy softens to sand and line icons turn champagne. Headings, buttons and links keep their colour */
(function () {
  'use strict';
  function rgb(s) { var m = (s || '').match(/[\d.]+/g); return m ? m.map(Number) : null; }
  function lum(c) { return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255; }
  function ground(el) {
    for (var p = el; p && p !== document.documentElement; p = p.parentElement) {
      var cs = getComputedStyle(p);
      if (cs.backgroundImage && cs.backgroundImage !== 'none' && !/gradient/.test(cs.backgroundImage)) return 'img';
      if (p.querySelector && p !== el && p.matches('.pg-hero,.hero,.pg-tile,.cd,.has-ov,.stat-im,.sg-plate,.pg-split-i')) return 'img';
      var c = rgb(cs.backgroundColor);
      if (c && (c.length < 4 || c[3] > 0.6)) return lum(c) < 0.3 ? 'd' : 'l';
    }
    return 'l';
  }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.home .lbl:not([data-sg-t]), .pgv .lbl:not([data-sg-t]), .cg .lbl:not([data-sg-t])'), function (l) {
      l.setAttribute('data-sg-t', '1');
      if (l.closest('a.btn, .btn, .pg-toc, .sg-hdr, #sg-menu, .ann, .sgr, .sgs-root')) return;
      var g = ground(l);
      if (g === 'img') return;
      l.classList.add(g === 'd' ? 'sg-tone-d' : 'sg-tone-l');
    });
    Array.prototype.forEach.call(document.querySelectorAll('.home p:not([data-sg-t]), .pgv p:not([data-sg-t]), .home li:not([data-sg-t]), .home .sm:not([data-sg-t])'), function (p) {
      p.setAttribute('data-sg-t', '1');
      if (p.classList.contains('lbl') || p.closest('a, button, .btn, h1, h2, h3, .ann, .sgr, .pg-hero, .hero, .pg-tile, .cd, .has-ov, .stat-im')) return;
      var c = rgb(getComputedStyle(p).color);
      if (!c || c[0] < 245 || c[1] < 245 || c[2] < 245) return;
      if (ground(p) !== 'd') return;
      p.classList.add('sg-soft');
    });
    Array.prototype.forEach.call(document.querySelectorAll('.home svg:not([data-sg-t]), .pgv svg:not([data-sg-t])'), function (s) {
      s.setAttribute('data-sg-t', '1');
      if (s.closest('a, button, .btn, .sg-hdr, .ann, .sgr, .sg-da, .pg-hero, .hero')) return;
      var st = getComputedStyle(s).stroke, c = rgb(st);
      if (!c || c[0] < 245) return;
      if (ground(s) === 'd') s.classList.add('sg-ic-d');
    });
  }
  function go() { run(); setTimeout(run, 1200); }
  if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
})();
/* images side by side always share one height and one baseline: every gallery row takes the median shape of its images and crops the rest to it */
(function () {
  'use strict';
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg-media'), function (g) {
      var ims = g.querySelectorAll(':scope > .pg-fig img');
      if (ims.length < 2) return;
      var rs = [];
      Array.prototype.forEach.call(ims, function (im) {
        var w = +im.getAttribute('width') || im.naturalWidth, h = +im.getAttribute('height') || im.naturalHeight;
        if (w && h) rs.push(w / h);
      });
      if (!rs.length) return;
      rs.sort(function (a, b) { return a - b; });
      var r = rs[Math.floor((rs.length - 1) / 2)];
      r = Math.max(.66, Math.min(1.78, r));
      g.style.setProperty('--sg-fig-ar', r.toFixed(4));
      g.classList.add('sg-even');
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
/* photo credits. Every SKINGRAPHICA photograph of a featured artist carries the artist, their status, the photographer and the copyright, in one place, top right of the frame */
(function () {
  'use strict';
  var A = {
    steve: ['Steve Butcher', 'Global Top 10 Artist', 'Karima Asaad'],
    mick: ['Mick Squires', 'Global Top 100 Artist', 'Karima Asaad'],
    chris: ['Chris Mata’afa', 'Global Top 100 Artist', 'Karima Asaad'],
    andrea: ['Andrea Pellerone', 'Global Top 100 Artist', 'Antonio Nelli'],
    marco: ['Marco C. Matarese', 'Global Top 100 Artist', 'Antonio Nelli'],
    duda: ['Duda Lozano', 'Global Top 100 Artist', 'Antonio Nelli'],
    brent: ['Brent McCown', 'Global Top 100 Artist', 'Sophia Miya-Smith'],
    coen: ['Coen Mitchell', 'Global Top 100 Artist', ''],
    dillon: ['Dillon Forte', 'Global Top 100 Artist', '']
  };
  var RX = /(?:^|[-_])(steve|mick|chris|andrea|marco|duda|brent|coen|dillon)(?=[-_.0-9]|$)/;
  var NOPH = /^steve_(butcher|trial)/;
  var FRAMES = '.pg-hero, .pg-split-i, .pg-fig, .pg-tile-i, .sga-hero, .sgbl-card-i, .sgbl-feat-i, .man-img, .nova-hero, .sgn-hero';
  var OUT = 'header, footer, .sg-hdr, #sg-menu, .mn, [role="dialog"], .sggr, .sgbi, [data-no-cr], .pcard, .pc, .sc';
  var P = location.pathname;
  if (/^\/blogs\/featured-artists/.test(P) || /^\/pages\/(worlds-top-|artists\/|rankings|global-rising|activate-)/.test(P)) return;
  function who(im) {
    var s = im.getAttribute('src') || im.getAttribute('data-src') || (im.getAttribute('srcset') || '').split(' ')[0] || '';
    var f = s.split('?')[0].split('/').pop().toLowerCase();
    try { f = decodeURIComponent(f); } catch (e) {}
    var m = f.match(RX); if (!m) return null;
    var a = A[m[1]]; return { a: a, ph: NOPH.test(f) ? '' : a[2] };
  }
  function frame(im) {
    var f = im.closest(FRAMES);
    if (f) return f;
    f = im.parentElement;
    if (f && /^(A|PICTURE)$/.test(f.nodeName)) f = f.parentElement;
    return f;
  }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('img'), function (im) {
      if (im.closest(OUT)) return;
      var w = who(im); if (!w) return;
      var fr = frame(im); if (!fr || fr.querySelector(':scope > .sg-cr')) return;
      if (fr.querySelector('.credit .cr2')) return; /* the homepage hero keeps its own photographer credit */
      Array.prototype.forEach.call(fr.querySelectorAll(':scope > .pg-credit, :scope > .credit, .pg-hero-in ~ .pg-credit'), function (c) { c.remove(); });
      if (getComputedStyle(fr).position === 'static') fr.style.position = 'relative';
      var p = document.createElement('p');
      p.className = 'sg-cr';
      p.setAttribute('data-no-mark', '');
      p.innerHTML = '<span class="sg-cr-a">' + w.a[0] + '</span><span class="sg-cr-s">' + w.a[1] + '</span>';
      var r = fr.getBoundingClientRect();
      if (r.top + window.scrollY < 40 && document.documentElement.classList.contains('sg-tp')) p.classList.add('sg-cr--hh');
      if (r.width && r.width < 520) p.classList.add('sg-cr--s');
      fr.appendChild(p);
    });
  }
  function watch() { run(); if (!window.MutationObserver) return; var q = false; new MutationObserver(function () { if (q) return; q = true; setTimeout(function () { q = false; run(); }, 120); }).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', watch);
  window.addEventListener('load', run);
})();
/* the visible window below the announcement bar, and the scroll cue on full window openings */
(function () {
  'use strict';
  var root = document.documentElement;
  function ab() {
    var h = document.querySelector('.sg-hdr-sec') || document.querySelector('.shopify-section-group-header-group .sg-hdr-sec');
    var t = h ? h.getBoundingClientRect().top + window.scrollY : 36;
    root.style.setProperty('--sg-ab', Math.max(0, Math.round(t)) + 'px');
  }
  function cue() {
    var hero = document.querySelector('.pgv .pg-hero--first:not(.pg-hero--short), .sg-tp .home .hero, html.sga .sga-hero--img, html.sgn-tp .iconica-hero__img-wrap, .cg-hero, .sgp .sgp-hero, .sgl .sgl-hero, .pgv .pg-intro--tex:has(.pg-ct a[href*="form.typeform.com/to/"])');
    if (hero && hero.getBoundingClientRect().height < window.innerHeight * .8) return;
    if (!hero || hero.querySelector('.sg-cue')) return;
    var a = document.createElement('a');
    a.className = 'sg-cue'; a.href = '#'; a.setAttribute('aria-label', 'Continue to the page');
    a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9.5l6 6 6-6"></path></svg>';
    a.addEventListener('click', function (e) { e.preventDefault(); var r = hero.getBoundingClientRect(), h = document.querySelector('.sg-hdr-sec'), cs = h ? getComputedStyle(h) : null, off = cs && (cs.position === 'sticky' || cs.position === 'fixed') ? h.offsetHeight : 0; window.scrollTo({ top: Math.max(0, window.scrollY + r.bottom - off), behavior: 'smooth' }); });
    hero.appendChild(a);
  }
  function sc() { root.classList.toggle('sg-scrolled', window.scrollY > 60); }
  function go() { ab(); cue(); sc(); if (window.MutationObserver) { var q = false; new MutationObserver(function () { if (q) return; q = true; setTimeout(function () { q = false; cue(); }, 150); }).observe(document.body, { childList: true, subtree: true }); } }
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
  window.addEventListener('load', function () { ab(); cue(); });
  window.addEventListener('resize', ab);
  window.addEventListener('scroll', sc, { passive: true });
})();
/* country lists. Any list whose items are all country names gets classic square flags from the theme assets */
(function () {
  var M = {'Australia':'au','Austria':'at','Belgium':'be','Canada':'ca','Denmark':'dk','Finland':'fi','France':'fr','Germany':'de','Hong Kong':'hk','Ireland':'ie','Japan':'jp','Luxembourg':'lu','Netherlands':'nl','New Zealand':'nz','Norway':'no','Poland':'pl','Singapore':'sg','South Korea':'kr','Sweden':'se','Switzerland':'ch','Taiwan':'tw','United Kingdom':'gb','United States':'us'};
  function run() {
    var l = document.querySelector('link[href*="sg-rd-x.css"]'); if (!l) return;
    var base = l.getAttribute('href').replace(/sg-rd-x\.css.*$/, '');
    Array.prototype.forEach.call(document.querySelectorAll('ul'), function (ul) {
      if (ul.classList.contains('sg-fl') || ul.closest('header,footer,nav,.sg-hdr-sec')) return;
      var li = ul.querySelectorAll(':scope > li'); if (li.length < 4) return;
      for (var i = 0; i < li.length; i++) if (!M[li[i].textContent.trim()]) return;
      ul.classList.add('sg-fl');
      Array.prototype.forEach.call(li, function (x) { var im = document.createElement('img'); im.src = base + 'sg-flag-' + M[x.textContent.trim()] + '.svg'; im.alt = ''; im.width = 22; im.height = 16; im.loading = 'lazy'; x.insertBefore(im, x.firstChild); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
/* rails. Any horizontal snap rail snaps to its own side padding, so the first card always starts inside the page margin on phones */
(function () {
  'use strict';
  function fix() {
    var all = document.querySelectorAll('main div, main ul, main ol, main section, .home div, .home ul');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.scrollWidth <= el.clientWidth + 1) continue;
      var c = getComputedStyle(el);
      if (!/x|both|inline/.test(c.scrollSnapType) || !/(auto|scroll)/.test(c.overflowX)) continue;
      var pl = parseFloat(c.paddingLeft) || 0, pr = parseFloat(c.paddingRight) || 0;
      if (pl <= 0) continue;
      var sp = parseFloat(c.scrollPaddingLeft);
      if (!(sp >= pl)) { el.style.scrollPaddingLeft = pl + 'px'; el.style.scrollPaddingRight = (pr || pl) + 'px'; }
      if (el.scrollLeft > 0 && el.scrollLeft <= pl + 1 && !el.__sgRailMoved) el.scrollLeft = 0;
      if (!el.__sgRailWatch) { el.__sgRailWatch = 1; el.addEventListener('scroll', function () { this.__sgRailMoved = 1; }, { passive: true, once: true }); }
    }
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(fix, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  window.addEventListener('load', fix);
  window.addEventListener('resize', soon);
})();

/* product tiles: on hover the bottle shot gives way to its lighter hover photograph, as on the product listings.
   Hover photographs are fetched and decoded ahead, as each tile comes into view, so the swap is instant with no blank frame */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
  var RE = /(skingraphica-(?:cutout-[a-z0-9-]+?|tight-system-lux))(-hover)?\.webp|\/SG_GiftCard(_Rollover)?[^\/?]*\.webp/;
  var GC_HV = '//skangraphica.com/cdn/shop/files/SG_GiftCard_Rollover_923d8d25-91e5-4891-9036-6f4eb191aa4f.webp';
  var on = null, cache = {};
  function hoverSrc(s) {
    var m = s.match(RE); if (!m || m[2] || m[3]) return null;
    if (!m[1]) return GC_HV;
    return s.split('?')[0].replace(RE, '$1-hover.webp');
  }
  function sized(img, hv) {
    var w = Math.ceil(((img.clientWidth || 300) * (window.devicePixelRatio || 1) * 1.25) / 200) * 200;
    return hv + '?width=' + Math.max(400, Math.min(1600, w));
  }
  function warm(img) {
    var hv = hoverSrc(img.getAttribute('src') || ''); if (!hv) return null;
    /* the hover photograph follows the picture the tile shows now, so after a size change (LUME 30 to 50) hovering shows the 50 and not the first size's photograph (26 Oct 2026) */
    if (img.__sgHvFor !== hv) { img.__sgHvFor = hv; img.__sgHv = sized(img, hv); img.__sgBase = null; }
    var url = img.__sgHv;
    if (!img.__sgBase) { var b = img.__sgBase = new Image(); b.src = img.getAttribute('src'); if (b.decode) b.decode().catch(function () {}); }
    var c = cache[url];
    if (!c) {
      var im = new Image(); im.decoding = 'async';
      c = cache[url] = { im: im, ready: false, cbs: [] };
      im.onload = function () {
        var done = function () { c.ready = true; c.cbs.splice(0).forEach(function (f) { f(); }); };
        im.decode ? im.decode().then(done, done) : done();
      };
      im.src = url;
    }
    return c;
  }
  /* thumbnails (size pickers, bag lines, search, kit steps) keep their picture, the swap is for product tiles only */
  var THUMB = '.bp-im,.sgb,.th,.em-th,#sg-search,.sgl-r,.ks,.cg-prod-im,.cg-out-rec,.sgc-up-i,.sgc-p-i,.sga-buy-i,.sga-note-i,[data-no-hover]';
  /* product tiles, stage collection pictures and the gift card are never thumbnails, whatever width the grid gives them (23 Oct 2026) */
  function thumb(im) {
    if (im.closest && im.closest('.tile,.cl-im,.cl-kt,.gv-card--img')) return !!im.closest(THUMB);
    return (im.clientWidth && im.clientWidth < 120) || !!(im.closest && im.closest(THUMB));
  }
  function tiles() { return [].filter.call(document.querySelectorAll('img'), function (im) { return !!hoverSrc(im.getAttribute('src') || '') && !thumb(im); }); }
  function arm() {
    var list = tiles(); if (!list.length) return;
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.target.clientWidth) { io.unobserve(e.target); idle(function () { warm(e.target); }); } });
      }, { rootMargin: '300px 0px' });
      list.forEach(function (im) { io.observe(im); });
    } else idle(function () { list.forEach(warm); });
  }
  if (document.readyState === 'complete') arm(); else window.addEventListener('load', arm);
  /* the host is the tile or card itself: the walk stops at section wrappers so hovering the copy beside the gift card no longer lights the card (23 Oct 2026) */
  function find(t) {
    var el = t;
    for (var i = 0; el && i < 6; i++, el = el.parentElement) {
      if (!el.querySelectorAll) continue;
      if (el.matches && el.matches('.gv,.wrap,main,section,body')) return null;
      var hit = [].filter.call(el.querySelectorAll('img'), function (im) { return RE.test(im.getAttribute('src') || ''); });
      if (hit.length === 1) return { host: el, img: hit[0] };
      if (hit.length > 1) return null;
    }
    return null;
  }
  /* responsive images (srcset) would keep showing the base picture, so srcset steps aside while hovered */
  function set(img, src) { img.loading = 'eager'; img.decoding = 'sync'; if (img.getAttribute('srcset')) { img.__sgSs = img.getAttribute('srcset'); img.removeAttribute('srcset'); } img.setAttribute('src', src); }
  /* the hover photograph takes the exact box of the bottle shot, so wide kits (SYSTEM PLUS, LUX) no longer jump to a smaller size when srcset steps aside (25 Oct 2026) */
  function lock(img) { if (img.__sgLk) return; var w = img.offsetWidth, h = img.offsetHeight; if (!w || !h) return; img.__sgLk = [img.style.width, img.style.height]; img.style.width = w + 'px'; img.style.height = h + 'px'; }
  function unlock(img) { if (!img.__sgLk) return; img.style.width = img.__sgLk[0]; img.style.height = img.__sgLk[1]; img.__sgLk = null; }
  function restore() { if (on && on.img.getAttribute('src') === on.hv) { set(on.img, on.base); if (on.img.__sgSs) { on.img.setAttribute('srcset', on.img.__sgSs); on.img.__sgSs = null; } } if (on) unlock(on.img); on = null; }
  document.addEventListener('mouseover', function (e) {
    if (on && on.host.contains(e.target)) return;
    restore();
    var f = find(e.target); if (!f) return;
    if (thumb(f.img)) return;
    var base = f.img.getAttribute('src'); if (!hoverSrc(base)) return;
    var c = warm(f.img); if (!c) return;
    var cur = on = { host: f.host, img: f.img, base: base, hv: f.img.__sgHv };
    function swap() { if (on === cur && cur.img.getAttribute('src') === cur.base) { lock(cur.img); set(cur.img, cur.hv); } }
    c.ready ? swap() : c.cbs.push(swap);
  });
  document.addEventListener('mouseout', function (e) { if (on && (!e.relatedTarget || !on.host.contains(e.relatedTarget))) restore(); });
})();
/* product page reviews. The reviews app grows its block by several hundred pixels after it loads, which pushed the page around on phones
   when it finished after the visitor had scrolled past. The block now sits in a fixed window with a fade, and opens in full on request */
(function () {
  function bg(el) {
    for (var e = el; e && e !== document.documentElement; e = e.parentElement) {
      var c = getComputedStyle(e).backgroundColor;
      if (c && c !== 'transparent' && !/rgba\(\d+, ?\d+, ?\d+, ?0\)/.test(c)) return c;
    }
    return '#fff';
  }
  function setup(w) {
    if (w.__sgOpen) return;
    var cap = window.innerWidth < 750 ? 1400 : 1200;
    if (!w.__sgCap) {
      w.__sgCap = 1;
      var b = w.__sgBtn = document.createElement('button');
      b.type = 'button'; b.className = 'btn sgc-ghost rv-more'; b.textContent = 'Read all reviews';
      b.addEventListener('click', function () { w.__sgOpen = 1; w.classList.remove('rv-cap'); b.remove(); });
      w.__sgChk = function () {
        if (w.__sgOpen) return;
        var short = w.scrollHeight <= cap + 160;
        if (w.classList.contains('rv-short') !== short) w.classList.toggle('rv-short', short);
        b.hidden = short;
      };
      if (window.ResizeObserver) new ResizeObserver(w.__sgChk).observe(w.firstElementChild || w);
      window.addEventListener('load', w.__sgChk);
    }
    if (!w.classList.contains('rv-cap')) {
      w.style.setProperty('--rv-cap', cap + 'px');
      w.style.setProperty('--rv-bg', bg(w.parentElement));
      w.classList.add('rv-cap');
    }
    if (!w.__sgBtn.isConnected || w.__sgBtn.previousElementSibling !== w) w.parentNode.insertBefore(w.__sgBtn, w.nextSibling);
    w.__sgChk();
  }
  function run() { Array.prototype.forEach.call(document.querySelectorAll('.sgp .rv-widget'), setup); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  if (window.MutationObserver) { var q = false; new MutationObserver(function () { if (q) return; q = true; setTimeout(function () { q = false; run(); }, 200); }).observe(document.documentElement, { childList: true, subtree: true }); }
})();
/*FOCAL-START*/
/* subject-aware cropping. Every photograph that is cropped to fill its frame carries a record of where its subject sits (a box, and for people the point
   to keep in view, usually the head). On every screen size the crop is worked out so the subject sits centred in the frame, whole when it fits,
   and anchored on the head when it cannot fit. Records live in rd/src/focal.json */
(function () {
  var F = {"skingraphica-founders-mat-and-mikael.webp":[0.12,0.08,0.9,1.0,0.5,0.22],"skingraphica-lab-cream-pour.webp":[0.29,0.0,0.68,1.0,0.48,0.7],"mick-squires-flower-throne.webp":[0.15,0.08,0.82,0.82,0.5,0.22],"mick-squires-studio-bw.webp":[0.22,0.22,0.62,0.82,0.4,0.35],"SG_OurStoryHeader.webp":[0.5,0.18,0.84,0.88,0.66,0.5],"skingraphica-gel-drop-sandstone.webp":[0.36,0.22,0.58,0.62],"155KingSt.jpg":[0.05,0.3,0.95,0.97,0.62,0.6],"SG_CareGuide.jpg":[0.2,0.1,1.0,0.7],"SG_History.jpg":[0.38,0.0,0.78,0.95,0.62,0.12],"SG_History_Artists.jpg":[0.05,0.15,0.75,0.95,0.35,0.35],"SG_History_Culture.jpg":[0.1,0.15,0.92,0.92,0.25,0.4],"SG_History_Milestones.jpg":[0.12,0.05,0.95,1.0,0.55,0.4],"SG_History_Styles.jpg":[0.05,0.05,0.85,0.95,0.42,0.35],"SG_Lock_Ingredients.jpg":[0.28,0.1,0.72,1.0],"SG_Lock_Ingredients_1ce5e1a2-4e21-43e2-9acd-e2c759e2419a.jpg":[0.28,0.1,0.72,1.0],"SG_Lume_Application.jpg":[0.2,0.1,0.95,0.7],"SG_Prime_Application.jpg":[0.45,0.0,0.8,0.65],"SG_Prime_Ingredients.jpg":[0.45,0.08,0.88,0.6],"SG_Range_82aaae79-5b84-471c-a384-60fc80b52feb.webp":[0.12,0.05,0.88,0.95],"SG_Science.jpg":[0.12,0.15,0.92,1.0,0.48,0.6],"SG_Shield_Box.webp":[0.28,0.08,0.73,1.0],"SG_Status.jpg":[0.15,0.3,0.85,0.7],"SG_SunSmart.jpg":[0.25,0.0,1.0,0.75,0.6,0.4],"SG_TypeHeader_Busted_8cd0630e-df28-4a46-94d7-94e0fa176d04.jpg":[0.12,0.25,0.9,0.75],"SG_TypeHeader_Fails.jpg":[0.2,0.15,0.8,0.85],"Steve-Coffee.jpg":[0.15,0.3,0.9,0.75,0.52,0.42],"Steve-Lounge.jpg":[0.22,0.25,0.72,0.7,0.53,0.38],"Steve_Butcher_Bird.jpg":[0.5,0.0,0.78,1.0],"andrea-attic-hero-desktop.webp":[0.35,0.15,0.65,0.97],"andrea-attic-hero-phone.webp":[0.35,0.1,0.65,0.95],"andrea-pellerone-bare-back.webp":[0.25,0.18,0.75,0.8,0.5,0.3],"brent-mccown-rainforest-desktop.webp":[0.15,0.12,0.62,0.78,0.3,0.22],"brent-mccown-rainforest-phone.webp":[0.08,0.05,0.9,0.95,0.4,0.2],"chris-mataafa-sandstone-desktop.webp":[0.42,0.35,0.6,0.78,0.5,0.45],"chris-mataafa-sandstone-phone.webp":[0.3,0.38,0.66,0.8,0.55,0.45],"coen-mitchell-beach-suit.webp":[0.42,0.0,0.72,1.0,0.58,0.12],"dillon-forte-library-chair.webp":[0.22,0.25,0.78,0.98,0.5,0.42],"dillon-forte-praying-hands.webp":[0.1,0.05,0.9,1.0,0.5,0.42],"dillon-forte-sunset.webp":[0.35,0.2,1.0,0.9,0.75,0.33],"duda-lozano-flame-wall.webp":[0.42,0.05,0.65,1.0,0.55,0.2],"marco-cover-tall.webp":[0.3,0.3,0.7,0.75,0.5,0.45],"marco-cover-wide.webp":[0.42,0.28,0.82,1.0,0.6,0.42],"sgr-Cleo_Lume_After.webp":[0.2,0.0,0.8,0.65,0.5,0.3],"sgr-Cleo_Lume_Before.webp":[0.15,0.15,0.85,0.95],"sgr-SG_Lume_Comparison_Allan_A.webp":[0.3,0.0,1.0,1.0],"sgr-SG_Lume_Comparison_Allan_B.webp":[0.3,0.0,1.0,1.0],"sgr-SG_Lume_Comparison_Chilli_A.webp":[0.3,0.0,0.85,0.9],"sgr-SG_Lume_Comparison_Chilli_B.webp":[0.3,0.0,0.85,0.9],"sgr-SG_Lume_Comparison_Square_TomE_A.webp":[0.15,0.15,0.9,0.82,0.5,0.42],"sgr-SG_Lume_Comparison_Square_TomE_B.webp":[0.15,0.15,0.9,0.82,0.5,0.42],"sgr-Skingraphica_LUME_TRIAL_FERNANDO_1_AFTER.webp":[0.05,0.0,0.95,0.92],"sgr-Steve_Trial.webp":[0.0,0.0,1.0,0.95],"sgr-barometer-forearm-tattoo_900x.jpg":[0.28,0.1,0.78,0.85],"sgr-dark-skin-tattoo_900x.jpg":[0.1,0.0,1.0,0.8],"sgr-day10_563x.jpg":[0.15,0.12,0.92,0.85,0.5,0.45],"sgr-day1_563x.jpg":[0.15,0.12,0.92,0.85,0.5,0.45],"sgr-ink-in-your-lymph-nodes-cover_900x.jpg":[0.2,0.15,0.8,0.75],"sgr-light_1440x.jpg":[0.15,0.25,0.75,0.75,0.4,0.45],"sgr-ozempic-tattoo-cover_900x.jpg":[0.3,0.05,0.7,0.85],"sgr-session_880x.jpg":[0.05,0.0,0.85,0.75],"sgr-skin_1400x.jpg":[0.15,0.05,0.9,1.0,0.45,0.3],"sgr-why_0052_1400x.jpg":[0.35,0.28,0.75,0.95,0.5,0.4],"sgr-why_1135_1400x.jpg":[0.2,0.1,0.8,0.75,0.45,0.4],"sgr-why_2261_1400x.jpg":[0.2,0.15,0.8,0.75,0.5,0.45],"sgr-why_brent_hands.webp":[0.15,0.35,0.8,0.8],"sgr-why_brent_stone.webp":[0.0,0.25,0.85,0.75],"sgr-why_marco_arch.webp":[0.3,0.25,0.75,0.75],"sgr-why_marco_silence.webp":[0.05,0.0,0.85,0.75,0.35,0.2],"skingraphica-amber-vial-dark-lab.webp":[0.3,0.2,0.68,0.8],"skingraphica-black-ink-splash.webp":[0.42,0.0,0.75,0.9],"skingraphica-bronze-face-ink.webp":[0.12,0.0,0.88,1.0],"skingraphica-cream-pearl-drop.webp":[0.42,0.28,0.62,0.68],"skingraphica-droplet-over-black-liquid.webp":[0.2,0.3,0.78,0.78,0.5,0.55],"skingraphica-ink-safe-gel-and-pigment.webp":[0.2,0.3,0.92,0.82,0.42,0.55],"skingraphica-lume-texture.webp":[0.2,0.1,0.82,0.95],"skingraphica-prime-actives.webp":[0.1,0.25,0.78,0.75],"skingraphica-prime-texture.webp":[0.05,0.2,0.75,0.9],"skingraphica-shield-actives.webp":[0.25,0.15,0.75,0.8],"skingraphica-shield-and-lume.webp":[0.22,0.08,0.82,0.98],"skingraphica-shield-texture.webp":[0.15,0.05,0.85,0.7],"skingraphica-signature-studio-interior.webp":[0.2,0.15,0.8,0.85],"skingraphica-stone-monolith-corridor.webp":[0.3,0.2,0.7,0.95],"marco-work-corvi-crop.webp":[0.15,0.0,0.85,1.0],"marco-work-gibson.webp":[0.15,0.05,0.8,0.8],"steve-work1.jpg":[0.2,0.05,0.8,0.85,0.5,0.35],"coen-work-pirate-sleeve.webp":[0.2,0.0,0.75,1.0],"ink-in-your-lymph-nodes-cover-8727942.webp":[0.2,0.15,0.8,0.75],"ozempic-tattoo-cover_4d3c47d8-e44f-49f3-b505-4966220d183e-5216059.webp":[0.3,0.05,0.7,0.85],"barometer-forearm-tattoo_bfc8fb5b-1344-40ca-8380-35313e0c00cb-3694799.webp":[0.28,0.1,0.78,0.85],"dark-skin-tattoo_4deb2be1-6020-4838-a168-d72b1d549c17-3741042.webp":[0.1,0.0,1.0,0.8],"cold-sweat-cover_f90a20fe-551b-408f-ad6c-3b0bdf9e0387-6306272.webp":[0.28,0.15,0.75,1.0,0.5,0.3],"most-tattooed-bodies_b36d37f8-5f5b-4af3-a6e5-ab427024677e-2326840.webp":[0.3,0.05,0.75,1.0,0.5,0.3],"basketball-sg-colours-2460427.webp":[0.3,0.0,0.75,0.95],"roger-ebert-robert-mitchum-1_32e6d2c6-e2c2-4a5f-a0b2-eb3fb91b438a.jpg":[0.2,0.3,0.9,1.0],"tattoo-pain_5a721a79-6e4d-42b0-b6e1-f62f014bf25c.webp":[0.32,0.0,0.75,0.9,0.53,0.25],"tattoo-elite_76c4e226-c2d8-4e1c-b71a-34270bb0bcc1.webp":[0.32,0.12,0.62,1.0,0.47,0.25],"tattoo-split-personality.webp":[0.25,0.05,0.95,0.95],"supermarket-aftercare-1839712-2039046-3224614_950f594d-58b2-494b-9881-f238eb0f5e81-9868341.png":[0.48,0.15,0.88,1.0,0.62,0.3],"skincloseup-hydration-9966131_3843fa6a-999b-4c97-bd93-b1441ac66423.png":[0.1,0.05,0.5,0.8],"M_a_judge_at_their_chair_with_a_gavel_in_a_courtroom_it_is_mo_0-8085585_d596735e-d7a4-4d44-a2ae-6d5e20d5180d-5464356.png":[0.28,0.0,0.75,1.0,0.5,0.2],"eulogy-6793139_79a0a84a-6d41-41a2-bd17-02803bb9a3f9-4191302.png":[0.4,0.2,0.95,0.85],"Andres-Cover_3415ac82-690f-4693-8a9a-55427fbf32b7.jpg":[0.25,0.1,0.8,1.0,0.5,0.33],"face_tattoo_runway_context_fbc6c476-95d4-4fd8-b6a0-f2186db2ce83.jpg":[0.25,0.15,0.75,1.0,0.5,0.33],"adwoa_aboah_tattoo_portrait-9287087-2676935_c89b3be3-08d3-4f1b-bd89-df07de578024-3611826.png":[0.15,0.05,0.9,0.95,0.5,0.35],"brent-cover.webp":[0.15,0.08,0.6,0.7,0.27,0.22],"duda-cover.webp":[0.42,0.05,0.68,1.0,0.55,0.2],"andrea-cover_c06ab12b-2f06-4121-9526-adad2d844909.jpg":[0.38,0.12,0.62,0.88,0.5,0.25],"SKINGRAPHICA-COEN-COVER.webp":[0.4,0.0,0.75,1.0,0.55,0.15],"dillon-cover-6253483-5602843_6522c3d1-b46e-48e3-96d1-18e73b173e03-5175640.jpg":[0.25,0.15,0.65,1.0,0.47,0.3],"Steve-Cover.jpg":[0.15,0.2,0.75,0.9,0.45,0.4],"chris-cover_28a60671-09c0-4450-9fef-cd68bf382296.jpg":[0.33,0.12,0.65,0.95,0.53,0.25],"mick-cover_5c9d4bff-151e-4e7a-8323-7ef92bf25cc2.jpg":[0.2,0.25,0.65,0.85,0.42,0.35],"woman-tattoo-preparation.webp":[0.12,0.05,0.72,1.0,0.4,0.25],"First48.webp":[0.1,0.0,0.7,0.95],"how-long-heal-tattoo.webp":[0.25,0.35,0.78,0.8],"sleep-tattoo-bedroom.webp":[0.15,0.45,0.85,0.95],"tattoo-sun-protection.webp":[0.3,0.0,0.7,1.0],"sunscreen-lotion-tattoo.webp":[0.35,0.1,0.98,0.75],"tattoo-fade-vibrant.webp":[0.3,0.25,0.8,0.7],"tattoo-infected.webp":[0.22,0.15,0.68,0.75],"Screenshot_2025-09-30_at_2.19.05_am.png":[0.28,0.0,0.68,1.0,0.47,0.35],"nova-jie-wu-portrait.webp":[0.3,0.05,0.75,1.0,0.5,0.2],"nova-jiho-yoon-portrait.webp":[0.3,0.2,0.85,0.9,0.55,0.45],"nova-peste-portrait.webp":[0.25,0.15,0.8,0.9,0.5,0.4],"nova-andres-makishi-portrait.webp":[0.35,0.1,0.65,1.0,0.5,0.35],"nova-minh-pham-portrait.webp":[0.25,0.1,0.8,0.9,0.5,0.3],"nova-aldo-moreno-portrait.webp":[0.2,0.15,0.8,0.95,0.45,0.35],"nova-lolita-malenkina-portrait.webp":[0.3,0.15,0.9,0.9,0.6,0.4],"nova-arlen-bellotti-portrait.webp":[0.3,0.2,0.9,0.95,0.6,0.45],"nova-mingyuan-yin-portrait.webp":[0.2,0.1,0.8,0.95,0.45,0.35],"nova-poesis-portrait.webp":[0.15,0.1,0.8,0.95,0.45,0.45],"nova-jaeyun-lee-portrait.webp":[0.3,0.1,0.95,0.9,0.6,0.35],"skingraphica-hall-of-fame-frames.webp":[0.05,0.15,0.95,0.6],"skingraphica-science-of-tattoo-recovery.jpg":[0.28,0.4,0.52,0.7],"skingraphica-science-of-tattoo-restoration.jpg":[0.43,0.3,0.67,0.6],"skingraphica-science-of-tattoo-protection.jpg":[0.36,0.3,0.6,0.6],"skingraphica-preparing-skin-before-a-tattoo.jpg":[0.38,0.3,0.62,0.6],"skingraphica-why-generic-aftercare-fails.jpg":[0.5,0.4,0.74,0.7],"skingraphica-tattoo-ink-in-lymph-nodes.jpg":[0.4,0.35,0.64,0.65],"skingraphica-tattoo-barometer-weather.jpg":[0.41,0.3,0.89,0.82],"skingraphica-nba-and-tattoos.jpg":[0.16,0.4,0.4,0.7],"skingraphica-do-tattoos-change-sweat.jpg":[0.36,0.25,0.6,0.55],"skingraphica-tattoo-on-darker-skin.jpg":[0.37,0.3,0.61,0.6],"skingraphica-most-tattooed-people.jpg":[0.38,0.23,0.62,0.53],"skingraphica-ozempic-tattoo.jpg":[0.38,0.3,0.62,0.6],"skingraphica-tattoo-symbols-meaning.jpg":[0.38,0.3,0.62,0.6],"skingraphica-how-tattooed-skin-heals.jpg":[0.43,0.3,0.67,0.6],"skingraphica-why-tattoos-are-permanent.jpg":[0.38,0.25,0.62,0.55],"skingraphica-tattooed-professional-class.jpg":[0.43,0.25,0.67,0.55],"skingraphica-why-tattoo-pain-matters.jpg":[0.4,0.25,0.64,0.55],"skingraphica-tattoo-aftercare-first-48-hours.jpg":[0.4,0.4,0.64,0.7],"skingraphica-best-cream-for-new-tattoo.jpg":[0.33,0.15,0.8,0.72],"skingraphica-dermatologist-tattoo-aftercare-guide.jpg":[0.43,0.25,0.67,0.55],"skingraphica-how-long-tattoo-takes-to-heal.jpg":[0.36,0.27,0.6,0.57],"skingraphica-showering-with-new-tattoo.jpg":[0.56,0.35,0.8,0.65],"skingraphica-sleeping-with-new-tattoo.jpg":[0.43,0.4,0.67,0.7],"skingraphica-sunscreen-lotion-for-tattoos.jpg":[0.4,0.1,0.99,0.62],"skingraphica-swimming-with-new-tattoo.jpg":[0.63,0.15,0.87,0.45],"skingraphica-why-tattoos-fade.jpg":[0.38,0.4,0.62,0.7],"skingraphica-is-my-tattoo-infected.jpg":[0.5,0.2,0.74,0.5],"skingraphica-how-to-apply-lotion-new-tattoo.jpg":[0.43,0.25,0.67,0.55],"skingraphica-tattoo-sun-protection-tips.jpg":[0.38,0.25,0.62,0.55],"skingraphica-preparing-for-first-tattoo.jpg":[0.63,0.3,0.87,0.6],"skingraphica-hall-of-fame-gallery.jpg":[0.38,0.25,0.62,0.55],"skingraphica-our-story-tattoo-chair.jpg":[0.3,0.12,0.77,0.86],"skingraphica-hand-beaten-copper.jpg":[0.48,0.25,0.72,0.55],"skingraphica-cream-and-golden-oil.jpg":[0.33,0.35,0.57,0.65],"skingraphica-torn-paper-ink-layer.jpg":[0.38,0.35,0.62,0.65],"skingraphica-be-skin-smart-sun.jpg":[0.23,0.2,0.47,0.5],"skingraphica-tattoo-care-faqs.jpg":[0.25,0.17,0.78,0.73],"skingraphica-how-inked-skin-is-different.jpg":[0.33,0.25,0.57,0.55],"skingraphica-how-tattooing-works.jpg":[0.36,0.25,0.6,0.55],"skingraphica-tattoos-and-the-law.jpg":[0.24,0.08,0.76,0.8],"skingraphica-signature-studio-atelier.jpg":[0.38,0.4,0.62,0.7],"skingraphica-studio-partner-tattoo-studio.jpg":[0.36,0.45,0.6,0.75],"skingraphica-signature-studio-setup.jpg":[0.28,0.35,0.52,0.65],"skingraphica-built-to-last-limestone.jpg":[0.36,0.36,0.65,0.61],"skingraphica-tattoo-care-guide-card.jpg":[0.36,0.3,0.6,0.6],"skingraphica-care-by-stage-card.jpg":[0.33,0.35,0.57,0.65],"skingraphica-concierge-contact-card.jpg":[0.43,0.4,0.67,0.7],"skingraphica-stylist-concierge-card.jpg":[0.38,0.45,0.62,0.75],"skingraphica-definitive-care-guide-card.jpg":[0.33,0.3,0.57,0.6],"skingraphica-above-the-ink.jpg":[0.53,0.35,0.77,0.65],"skingraphica-hybrid-laboratory.jpg":[0.5,0.3,0.74,0.6],"skingraphica-care-stage-prepare.jpg":[0.38,0.4,0.62,0.7],"skingraphica-care-stage-recover.jpg":[0.38,0.4,0.62,0.7],"skingraphica-care-stage-protect.jpg":[0.33,0.25,0.57,0.55],"skingraphica-care-stage-restore.jpg":[0.38,0.3,0.62,0.6],"mick-squires-studio.webp":[0.22,0.22,0.62,0.82,0.4,0.35]};
  function key(img) {
    var u = img.currentSrc || img.getAttribute('src') || ''; if (!u) return null;
    var n = u.split('?')[0].split('/').pop(); try { n = decodeURIComponent(n); } catch (x) {}
    if (F[n]) return F[n];
    var n2 = n.replace(/_(\d+x\d*|\d*x\d+)(?=\.[a-z]+$)/i, ''); if (F[n2]) return F[n2];
    /* an article image uploaded twice carries a _uuid suffix */
    var n3 = n2.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.[a-z]+$)/i, ''); return F[n3] || null;
  }
  function axis(a0, a1, an, S, B, head) {
    if (S - B < 1) return 50;
    var L, sub = (a1 - a0) * S;
    if (sub <= B) { L = (a0 + a1) / 2 * S - B / 2; L = Math.min(Math.max(L, a1 * S - B), a0 * S); }
    else if (an != null) { L = an * S - B * (head ? 0.36 : 0.5); L = Math.min(Math.max(L, a0 * S - B * 0.02), a1 * S - B * 0.98); }
    else L = (a0 + a1) / 2 * S - B / 2;
    L = Math.max(0, Math.min(S - B, L));
    return L / (S - B) * 100;
  }
  function fit(img) {
    if (img.closest && img.closest('.gi, .sg-zm')) return; /* product gallery and zoom viewer frame their own images */
    var f = key(img); if (!f) return;
    var cs = getComputedStyle(img);
    if (cs.objectFit !== 'cover') { if (img.__sgF) { img.style.objectPosition = ''; img.__sgF = 0; } return; }
    var bw = img.clientWidth, bh = img.clientHeight, nw = img.naturalWidth || +img.getAttribute('width'), nh = img.naturalHeight || +img.getAttribute('height');
    if (!bw || !bh || !nw || !nh) return;
    /* a full width frame on a phone that is too narrow or too short for the subject takes the photograph's own shape instead, so nothing is cut */
    var par = img.parentElement, pcs = par && getComputedStyle(par);
    if (par && (par.__sgAR0 || (pcs.aspectRatio && pcs.aspectRatio !== 'auto')) && Math.abs(par.clientWidth - bw) < 2) {
      if (!par.__sgAR0) par.__sgAR0 = pcs.aspectRatio;
      var m = String(par.__sgAR0).match(/([\d.]+)\s*\/\s*([\d.]+)/), ar0 = m ? (+m[1] / +m[2]) : (+par.__sgAR0 || 0);
      var phone = window.innerWidth < 750 && bw >= window.innerWidth * 0.85;
      if (ar0 && phone) {
        var h0 = bw / ar0, s0 = Math.max(bw / nw, h0 / nh), fitsX = (f[2] - f[0]) * nw * s0 <= bw + 1, fitsY = (f[3] - f[1]) * nh * s0 <= h0 + 1;
        var want = (fitsX && fitsY) ? '' : (nw + ' / ' + nh);
        if (par.style.aspectRatio.replace(/\s/g, '') !== want.replace(/\s/g, '')) { par.style.aspectRatio = want; bw = img.clientWidth; bh = img.clientHeight; }
      } else if (par.style.aspectRatio) { par.style.aspectRatio = ''; bw = img.clientWidth; bh = img.clientHeight; }
    }
    var s = Math.max(bw / nw, bh / nh), W = nw * s, H = nh * s;
    var px = axis(f[0], f[2], f.length > 4 ? f[4] : null, W, bw, false), py = axis(f[1], f[3], f.length > 5 ? f[5] : null, H, bh, true);
    var v = px.toFixed(1) + '% ' + py.toFixed(1) + '%';
    if (img.style.objectPosition !== v) img.style.objectPosition = v;
    img.__sgF = 1;
  }
  function all() { Array.prototype.forEach.call(document.images, function (im) { if (!im.__sgFL) { im.__sgFL = 1; im.addEventListener('load', function () { fit(im); }); } fit(im); }); }
  var t = null; function soon() { clearTimeout(t); t = setTimeout(all, 120); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  window.addEventListener('load', all); window.addEventListener('resize', soon);
  if (window.ResizeObserver) { var ro = new ResizeObserver(soon); ro.observe(document.documentElement); }
  if (window.MutationObserver) new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'class'] });
  window.SGFocal = { fit: fit, all: all, F: F };
})();
/*FOCAL-END*/
/* stage collections. Moving between 01 to 04 keeps the reader's place on the page instead of returning to the top, and the next stage is fetched on hover so the swap feels instant */
(function () {
  'use strict';
  var K = 'sg-stage-y';
  function nav(e) { return e.target && e.target.closest ? e.target.closest('.cl-nav a[href^="/collections/"]') : null; }
  document.addEventListener('click', function (e) {
    var a = nav(e); if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    try { sessionStorage.setItem(K, JSON.stringify({ y: Math.round(window.scrollY), t: Date.now(), to: a.pathname })); } catch (_) {}
  }, true);
  var seen = {};
  function warm(e) {
    var a = nav(e); if (!a || seen[a.href] || a.classList.contains('on')) return; seen[a.href] = 1;
    var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', warm);
  var s = null;
  try { s = JSON.parse(sessionStorage.getItem(K) || 'null'); sessionStorage.removeItem(K); } catch (_) {}
  if (!s || Date.now() - s.t > 20000 || s.to !== location.pathname || location.hash || !s.y) return;
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  var set = -1;
  function go(late) {
    if (late && set >= 0 && Math.abs(window.scrollY - set) > 4) return;
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    set = Math.min(s.y, max);
    window.scrollTo({ top: set, left: 0, behavior: 'instant' });
  }
  if (document.readyState !== 'loading') go(false); else document.addEventListener('DOMContentLoaded', function () { go(false); });
  window.addEventListener('load', function () { go(true); }, { once: true });
})();
/* applications. An Apply button in the page header that points at a Typeform opens that form full screen over the page, a clean space to complete it, and returns to the page when closed */
(function () {
  'use strict';
  var SRC = 'https://embed.typeform.com/next/embed.js', loading = null;
  function sdk() {
    if (window.tf && window.tf.createPopup) return Promise.resolve(window.tf);
    if (loading) return loading;
    loading = new Promise(function (ok, no) {
      if (!document.querySelector('link[data-sg-tf]')) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = 'https://embed.typeform.com/next/css/popup.css'; l.setAttribute('data-sg-tf', ''); document.head.appendChild(l); }
      var s = document.createElement('script'); s.src = SRC; s.async = true;
      s.onload = function () { window.tf && window.tf.createPopup ? ok(window.tf) : no(); };
      s.onerror = no; document.head.appendChild(s);
    });
    return loading;
  }
  function idOf(a) { var m = (a.getAttribute('href') || '').match(/form\.typeform\.com\/to\/([A-Za-z0-9]+)/); return m ? m[1] : ''; }
  function links() { return document.querySelectorAll('.pgv .pg-ct a[href*="form.typeform.com/to/"]'); }
  function warm() { if (links().length) sdk().catch(function () {}); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="form.typeform.com/to/"]') : null;
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var id = idOf(a); if (!id) return;
    e.preventDefault();
    a.setAttribute('aria-busy', 'true');
    sdk().then(function (tf) {
      a.removeAttribute('aria-busy');
      var p = tf.createPopup(id, { size: 100, opacity: 100, medium: 'snippet', transitiveSearchParams: true, iframeProps: { title: a.textContent.trim() || 'Application' }, onClose: function () { a.focus(); } });
      p.open();
    }, function () { a.removeAttribute('aria-busy'); window.location.href = a.href; });
  });
  if (document.readyState !== 'loading') warm(); else document.addEventListener('DOMContentLoaded', warm);
})();

/* single bottle shots carry their soft shadow to the right of the bottle, so the bottle sits left of the image centre.
   Where a bottle is centred by its image box, shift it by the shadow so the bottle itself sits dead centre */
(function () {
  var SEL = '#sg-search .sgl-r i img,.cg .cg-prod-im img,.cg .cg-out-rec img,.sgc .sgc-up-i img,.sgc .sgc-p-i img,.sga-buy-i img,.sga-note-i img';
  var ONE = /skingraphica-cutout-(prime|lock|shield|lume)|sgr-p_(prime|lock|shield|lume)/;
  function fix(im) {
    if (!ONE.test(im.getAttribute('src') || '') || !im.naturalWidth || !im.clientWidth) { im.style.translate = ''; return; }
    var fit = getComputedStyle(im).objectFit, w = im.clientWidth, h = im.clientHeight, ar = im.naturalWidth / im.naturalHeight;
    var rw = (fit === 'contain' || fit === 'scale-down') ? Math.min(w, h * ar) : w;
    im.style.translate = (0.143 * rw).toFixed(1) + 'px 0';
  }
  function all() {
    [].forEach.call(document.querySelectorAll(SEL), function (im) {
      if (im.complete) fix(im); else if (!im.__sgC) { im.__sgC = 1; im.addEventListener('load', function () { fix(im); }); }
    });
  }
  var t; function soon() { clearTimeout(t); t = setTimeout(all, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  window.addEventListener('resize', soon);
  if ('MutationObserver' in window) new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
})();
/* founder pricing. A founder code checked on the By invitation page redraws every shelf price at the shopper's private price.
   Only for a plain percentage on every product (sg-inv.js decides), never gift cards, never the bag (the bag shows Shopify's own totals).
   The code is re-checked with Shopify once a visit and whenever the shopper changes country */
(function () {
  'use strict';
  var KEY = 'sg-inv', root = document.documentElement;
  var me = document.currentScript, BASE = ((me && me.src) || '').replace(/sg-rd-x\.js.*$/, '');
  function st() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  var s = st();
  if (!s || !s.code) return;
  root.classList.add('sg-inv-on');
  var SOLO = '.price, .b-price .pr, .cg-prod-p, #sg-search .pr, #sg-search .price';
  var INLINE = 'button, a.btn, .btn .t1, .lf-b';
  var SKIP = '.sgb, .inv, .q-gift, .sgq-c, .sg-inv-chip, [data-no-inv], a[href*="gift-card"], [data-sg-add*="gift"]';
  function money(v) { var S = window.SG; if (S && S.money) return S.money(v); return '$' + (Math.round(v) === v ? v : v.toFixed(2)); }
  function num(t) {
    var m = t.match(/\d[\d.,  ' ]*\d|\d/); if (!m) return null;
    var c = m[0].replace(/[  ' ]/g, ''), d = c.match(/[.,](\d{2})$/);
    var v = d ? Number(c.slice(0, -3).replace(/[.,]/g, '') + '.' + d[1]) : Number(c.replace(/[.,]/g, ''));
    return isFinite(v) ? v : null;
  }
  function priced(v) { return Math.round(v * (1 - s.pct / 100) * 100) / 100; }
  function solo(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType !== 3 || !/\d/.test(n.nodeValue)) continue;
      var t = n.nodeValue, v = num(t); if (v === null) continue;
      var was = money(v); if (t.indexOf(was) < 0) continue;
      var w = document.createElement('s'); w.className = 'sg-inv-was'; w.textContent = was;
      var now = document.createElement('span'); now.className = 'sg-inv-now'; now.textContent = money(priced(v));
      var pre = t.slice(0, t.indexOf(was)), post = t.slice(t.indexOf(was) + was.length);
      var frag = document.createDocumentFragment();
      if (pre) frag.appendChild(document.createTextNode(pre));
      frag.appendChild(w); frag.appendChild(document.createTextNode(' ')); frag.appendChild(now);
      if (post) frag.appendChild(document.createTextNode(post));
      el.replaceChild(frag, n);
      el.setAttribute('data-sg-inv', '1');
      return;
    }
  }
  function inline(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType !== 3) continue;
      var t = n.nodeValue;
      if (!/^\s*(Add|Choose)\b/.test(t) || /Valued|value|over|Up to/i.test(t)) continue;
      var v = num(t); if (v === null) continue;
      var was = money(v); if (t.indexOf(was) < 0) continue;
      var nw = money(priced(v));
      n.nodeValue = t.replace(was, nw);
      n.__sgInv = n.nodeValue;
    }
  }
  /* products the code leaves out keep their full price (28 Oct 2026) */
  function left(el) {
    var ex = (s && s.ex) || []; if (!ex.length) return false;
    function is(h) { return new RegExp('/products/' + h.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:[/?#]|$)'); }
    var card = el.closest('.pc, .card, .sgc-kit, .cg-prod, .sr-ac, article, li');
    if (card) return ex.some(function (h) { var rx = is(h); return [].some.call(card.querySelectorAll('a[href]'), function (a) { return rx.test(a.getAttribute('href')); }) || (card.matches('a[href]') && rx.test(card.getAttribute('href'))); });
    return ex.some(function (h) { return is(h).test(location.pathname); });
  }
  function paint() {
    if (!s || !s.all || !(s.pct > 0 && s.pct < 100)) return;
    [].forEach.call(document.querySelectorAll(SOLO), function (el) {
      if (el.closest(SKIP) || el.querySelector('.sg-inv-now') || left(el)) return;
      if (/Valued|value|over|Up to/i.test(el.textContent) && !el.querySelector('.val')) return;
      solo(el);
    });
    [].forEach.call(document.querySelectorAll(INLINE), function (el) {
      if (el.closest(SKIP) || left(el)) return;
      for (var i = 0; i < el.childNodes.length; i++) { var n = el.childNodes[i]; if (n.nodeType === 3 && n.__sgInv === n.nodeValue) return; }
      inline(el);
    });
  }
  function chip() {
    if (document.querySelector('.sg-inv-chip') || !document.body) return;
    var d = document.createElement('div'); d.className = 'sg-inv-chip';
    var pct = s.all && s.pct ? String(s.pct).replace(/\.0$/, '') + '% off' : 'Code in your bag';
    d.innerHTML = '<a href="/pages/by-appointment"><span>Founder pricing</span><b></b></a><button type="button" aria-label="Remove founder pricing"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.8 6.8l10.4 10.4M17.2 6.8L6.8 17.2"/></svg></button>';
    d.querySelector('b').textContent = pct;
    d.querySelector('button').addEventListener('click', function () {
      try { localStorage.removeItem(KEY); } catch (e) {}
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: '' }) })
        .catch(function () {}).then(function () { location.reload(); });
    });
    document.body.appendChild(d);
  }
  var q = false;
  function go() {
    chip(); paint();
    if (window.MutationObserver) new MutationObserver(function () { if (q) return; q = true; setTimeout(function () { q = false; paint(); }, 120); }).observe(document.body, { childList: true, subtree: true, characterData: true });
    recheck();
  }
  function recheck() {
    var cc = window.Shopify && Shopify.country, seen = '';
    try { seen = sessionStorage.getItem('sg-inv-ok') || ''; } catch (e) {}
    if (seen && (!cc || cc === s.cc)) return;
    function run() {
      if (!window.SGINV) return;
      window.SGINV.recheck(cc).then(function (n) {
        try { sessionStorage.setItem('sg-inv-ok', '1'); } catch (e) {}
        if (!n || n.pct !== s.pct || n.all !== s.all) location.reload();
      });
    }
    if (window.SGINV) return run();
    document.addEventListener('sg:inv-ready', run, { once: true });
    var sc = document.createElement('script'); sc.src = (me && me.getAttribute('data-sginv')) || BASE + 'sg-inv.js'; sc.defer = true; document.head.appendChild(sc);
  }
  document.addEventListener('sg:inv', function (e) { s = e.detail; if (s) { chip(); paint(); } });
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
})();
/* planner key dates. The order by and begin PRIME dates lift out of the small print into 2 clear tiles above the timeline, with a count of days so the shopper sees how soon to act.
   Reads the planner's own sentences, so the dates always match the timeline. Anything it does not recognise (already done, appointment today) keeps the original lines */
(function () {
  'use strict';
  var MON = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
  var DT = '((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun)\\w* \\d{1,2} [A-Z][a-z]{2}\\w*)';
  function days(t) {
    var m = t.match(/(\d{1,2}) ([A-Z][a-z]{2})/); if (!m || !(m[2] in MON)) return null;
    var now = new Date(); now.setHours(0, 0, 0, 0);
    var d = new Date(now.getFullYear(), MON[m[2]], Number(m[1]));
    if (d < now - 864e5 * 60) d.setFullYear(d.getFullYear() + 1);
    return Math.round((d - now) / 864e5);
  }
  /* the English line, also on translated storefronts, where the language layer keeps it beside the translation */
  function src(e) {
    if (!e) return '';
    var t = e.textContent.replace(/\s+/g, ' ').trim(), en = e.getAttribute('data-sg-en');
    return en && e.getAttribute('data-sg-tx') === t ? en : t;
  }
  function when(n) { return n === null ? '' : n <= 0 ? 'Today' : n === 1 ? 'Tomorrow' : 'In ' + n + ' days'; }
  function read(plan) {
    var ps = plan.querySelector('.plan-s'), po = plan.querySelector('.plan-o2');
    var a = src(ps), b = src(po), m, out = { appt: '', tiles: [] };
    if ((m = a.match(new RegExp('^Appointment on ' + DT)))) out.appt = m[1];
    if ((m = b.match(new RegExp('^Order by ' + DT + ' to begin on time\\.\\s*(.*)$')))) out.tiles.push({ k: 'order', l: 'Order by', v: m[1], n: when(days(m[1])), s: m[2] });
    else if ((m = b.match(/^Order today to begin as soon as possible\.\s*(.*)$/))) out.tiles.push({ k: 'order', l: 'Order', v: 'Today', n: 'To begin as soon as possible', s: m[1] });
    if ((m = a.match(new RegExp('Begin PRIME on ' + DT + ', 21 days out')))) out.tiles.push({ k: 'prime', l: 'Begin PRIME', v: m[1], n: when(days(m[1])), s: '21 days before your appointment' });
    else if (/Begin PRIME today, 21 days out/.test(a)) out.tiles.push({ k: 'prime', l: 'Begin PRIME', v: 'Today', n: '', s: '21 days before your appointment' });
    else if (/Begin PRIME the day it arrives/.test(a)) out.tiles.push({ k: 'prime', l: 'Begin PRIME', v: 'The day it arrives', n: '', s: '21 days is ideal, but every day beforehand still counts.' });
    else if (/Begin PRIME today\./.test(a)) out.tiles.push({ k: 'prime', l: 'Begin PRIME', v: 'Today', n: '', s: '21 days is ideal, but every day beforehand still counts.' });
    return out;
  }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt) e.textContent = txt; return e; }
  function paint(plan) {
    var r = read(plan), sig = JSON.stringify(r), old = plan.querySelector('.sg-kd');
    if (old && old.getAttribute('data-sig') === sig) return;
    if (old) old.remove();
    if (!r.tiles.length) { plan.classList.remove('sg-kd-on'); return; }
    var box = el('div', 'sg-kd'); box.setAttribute('data-sig', sig); box.setAttribute('aria-hidden', 'true');
    if (r.appt) { var h = el('p', 'sg-kd-a'); h.appendChild(el('span', '', 'Your appointment')); h.appendChild(el('b', '', r.appt)); box.appendChild(h); }
    var g = el('div', 'sg-kd-g' + (r.tiles.length === 1 ? ' sg-kd-g--1' : ''));
    r.tiles.forEach(function (t) {
      var c = el('div', 'sg-kd-t sg-kd-t--' + t.k);
      var top = el('p', 'sg-kd-l'); top.appendChild(el('span', '', t.l)); if (t.n) top.appendChild(el('i', '', t.n)); c.appendChild(top);
      c.appendChild(el('p', 'sg-kd-v', t.v));
      if (t.s) c.appendChild(el('p', 'sg-kd-s', t.s));
      g.appendChild(c);
    });
    box.appendChild(g);
    var po = plan.querySelector('.plan-o2') || plan.querySelector('.plan-s');
    po.parentNode.insertBefore(box, po.nextSibling);
    plan.classList.add('sg-kd-on');
  }
  var q = false;
  function run() { [].forEach.call(document.querySelectorAll('.home .plan'), function (p) { if (p.querySelector('.plan-s')) paint(p); }); }
  function go() {
    run();
    if (window.MutationObserver) new MutationObserver(function (ms) {
      if (q) return;
      for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (t.nodeType === 3) t = t.parentNode; if (t && t.closest && t.closest('.plan') && !t.closest('.sg-kd')) { q = true; setTimeout(function () { q = false; run(); }, 60); return; } }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
  window.addEventListener('load', run);
})();

/* product pages. The phone sticky Add to bag stays out of the way until the main Add to bag button has scrolled away above, so the opening screen is the product and its copy. Robust to the product panel re-rendering */
(function () {
  'use strict';
  var de = document.documentElement, on = null, ticking = false;
  function check() {
    ticking = false;
    var b = document.querySelector('.home.sgp .bp > .btn.big');
    if (!b) return;
    if (!de.classList.contains('sg-pdp-io')) de.classList.add('sg-pdp-io');
    var want = b.getBoundingClientRect().bottom < 0;
    if (want !== on) { on = want; de.classList.toggle('sg-pdp-stk', want); }
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
  var started = false;
  function go() {
    if (started || !document.querySelector('.home.sgp')) return;
    started = true;
    check();
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
  }
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
  window.addEventListener('load', go);
})();

/* product gallery and zoom. The hero shows alone, the box shot and the texture are a swipe or an arrow away, with dots over the image.
   Tapping or clicking any image opens a full screen viewer on white: tap, click or pinch to zoom, drag or move the pointer to look around, swipe between images, Escape to close */
(function () {
  'use strict';
  function idx(t) { return t.clientWidth ? Math.round(t.scrollLeft / t.clientWidth) : 0; }
  function sync(gal) {
    var t = gal.querySelector('.gal-t'); if (!t) return;
    var n = t.children.length, i = Math.max(0, Math.min(n - 1, idx(t)));
    /* data-sg-x attributes survive the product panel re-rendering, classes would not */
    gal.toggleAttribute('data-sg-xm', n > 1);
    gal.toggleAttribute('data-sg-xmv', i > 0);
    [].forEach.call(gal.querySelectorAll('.g-dots i'), function (d, k) { d.toggleAttribute('data-sg-xon', k === i); });
    var p = gal.querySelector('.g-prev'), x = gal.querySelector('.g-next');
    if (p) { p.toggleAttribute('data-sg-xd', i === 0); p.setAttribute('aria-disabled', i === 0 ? 'true' : 'false'); }
    if (x) { x.toggleAttribute('data-sg-xd', i >= n - 1); x.setAttribute('aria-disabled', i >= n - 1 ? 'true' : 'false'); }
  }
  function all() { [].forEach.call(document.querySelectorAll('.home.sgp .gal'), sync); }
  var sq = false;
  document.addEventListener('scroll', function (e) {
    var t = e.target; if (!t || !t.classList || !t.classList.contains('gal-t')) return;
    if (sq) return; sq = true; requestAnimationFrame(function () { sq = false; sync(t.parentNode); });
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.home.sgp .g-nav');
    if (b) { if (b.hasAttribute('data-sg-xd')) return; var t = b.parentNode.querySelector('.gal-t'); if (t) t.scrollTo({ left: (idx(t) + Number(b.getAttribute('data-g'))) * t.clientWidth, behavior: 'smooth' }); return; }
    var f = e.target.closest && e.target.closest('.home.sgp .gal-t > .gi');
    if (f) { e.preventDefault(); open(f.parentNode, [].indexOf.call(f.parentNode.children, f)); }
  });

  /* the viewer */
  var Z = null;
  function big(src) {
    try { var u = new URL(src, location.href); if (/\/cdn\/shop\/|cdn\.shopify\.com/.test(u.href)) { u.searchParams.set('width', '2400'); u.searchParams.delete('height'); u.searchParams.delete('crop'); } return u.href; } catch (e) { return src; }
  }
  var SVG = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '"></path></svg>'; };
  function open(track, start) {
    if (Z) close();
    var ims = [].map.call(track.children, function (g) { var im = g.querySelector('img'); return { src: im ? (im.currentSrc || im.src) : '', alt: im ? im.alt : '', ed: g.classList.contains('ed') }; });
    var el = document.createElement('div');
    el.className = 'sg-zm' + (ims.length < 2 ? ' one' : '');
    el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', 'Product images');
    el.innerHTML = '<div class="sg-zm-t">' + ims.map(function (m) { return '<div class="sg-zm-f' + (m.ed ? ' ed' : '') + '"><img alt="" draggable="false"></div>'; }).join('') + '</div>'
      + '<p class="sg-zm-c" aria-live="polite"></p>'
      + '<button type="button" class="sg-zm-x" aria-label="Close">' + SVG('M6.5 6.5l11 11M17.5 6.5l-11 11') + '</button>'
      + '<button type="button" class="sg-zm-a sg-zm-p" aria-label="Previous image">' + SVG('M14.5 6l-6 6 6 6') + '</button>'
      + '<button type="button" class="sg-zm-a sg-zm-n" aria-label="Next image">' + SVG('M9.5 6l6 6-6 6') + '</button>'
      + '<p class="sg-zm-h">' + (window.matchMedia && matchMedia('(hover: hover)').matches ? 'Click to zoom' : 'Double tap or pinch to zoom') + '</p>';
    var imgs = el.querySelectorAll('.sg-zm-f img');
    ims.forEach(function (m, k) { imgs[k].alt = m.alt; imgs[k].src = m.src; var hi = big(m.src); if (hi !== m.src) { var pre = new Image(); pre.onload = function () { imgs[k].src = hi; }; pre.src = hi; } });
    document.body.appendChild(el);
    document.documentElement.classList.add('sg-zm-open');
    var t = el.querySelector('.sg-zm-t'), c = el.querySelector('.sg-zm-c'), back = document.activeElement;
    Z = { el: el, t: t, back: back, s: 1, x: 0, y: 0, img: null };
    function count() { var i = idx(t); c.textContent = ims.length > 1 ? (i + 1) + ' / ' + ims.length : ''; el.querySelector('.sg-zm-p').disabled = i === 0; el.querySelector('.sg-zm-n').disabled = i >= ims.length - 1; }
    t.scrollLeft = start * t.clientWidth;
    requestAnimationFrame(function () { t.scrollLeft = start * t.clientWidth; count(); el.classList.add('on'); });
    t.addEventListener('scroll', function () { reset(); count(); }, { passive: true });
    el.querySelector('.sg-zm-x').addEventListener('click', close);
    el.querySelector('.sg-zm-p').addEventListener('click', function () { t.scrollTo({ left: (idx(t) - 1) * t.clientWidth, behavior: 'smooth' }); });
    el.querySelector('.sg-zm-n').addEventListener('click', function () { t.scrollTo({ left: (idx(t) + 1) * t.clientWidth, behavior: 'smooth' }); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') t.scrollTo({ left: (idx(t) + 1) * t.clientWidth, behavior: 'smooth' });
      else if (e.key === 'ArrowLeft') t.scrollTo({ left: (idx(t) - 1) * t.clientWidth, behavior: 'smooth' });
      else if (e.key === 'Tab') { var f = [].slice.call(el.querySelectorAll('button:not([disabled])')).filter(function (b) { return b.offsetParent; }); if (!f.length) return; var a = f.indexOf(document.activeElement); if (e.shiftKey && a <= 0) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && a === f.length - 1) { e.preventDefault(); f[0].focus(); } }
    });
    [].forEach.call(imgs, gestures);
    el.querySelector('.sg-zm-x').focus({ preventScroll: true });
  }
  function close() {
    if (!Z) return;
    var z = Z; Z = null;
    z.el.classList.remove('on');
    document.documentElement.classList.remove('sg-zm-open');
    setTimeout(function () { z.el.remove(); }, 250);
    if (z.back && z.back.focus) try { z.back.focus({ preventScroll: true }); } catch (e) {}
  }
  function apply(img) { img.style.transform = Z.s > 1 ? 'translate(' + Z.x + 'px,' + Z.y + 'px) scale(' + Z.s + ')' : ''; Z.el.classList.toggle('zoomed', Z.s > 1); }
  function clamp(img) {
    var w = img.offsetWidth, h = img.offsetHeight, f = img.parentNode, W = f.clientWidth, H = f.clientHeight;
    var mx = Math.max(0, (w * Z.s - W) / 2), my = Math.max(0, (h * Z.s - H) / 2);
    Z.x = Math.max(-mx, Math.min(mx, Z.x)); Z.y = Math.max(-my, Math.min(my, Z.y));
  }
  function reset() { if (!Z || Z.s === 1) return; var im = Z.img; Z.s = 1; Z.x = 0; Z.y = 0; Z.img = null; if (im) { im.style.transition = ''; apply(im); } }
  /* zoom so the point under the finger or pointer stays put */
  function zoomAt(img, s, px, py) {
    var r = img.parentNode.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var qx = (px - cx - Z.x) / Z.s, qy = (py - cy - Z.y) / Z.s;
    Z.s = Math.max(1, Math.min(4, s)); Z.x = px - cx - Z.s * qx; Z.y = py - cy - Z.s * qy; Z.img = img;
    clamp(img); apply(img);
  }
  function gestures(img) {
    var pts = {}, start = null, lastTap = 0;
    img.style.transition = 'transform .25s ease';
    img.addEventListener('pointerdown', function (e) {
      if (!Z) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        start = { d: Math.hypot(a.x - b.x, a.y - b.y), s: Z.s, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2, x: Z.x, y: Z.y, pinch: true };
        img.style.transition = 'none'; Z.img = img;
        try { img.setPointerCapture(e.pointerId); } catch (x) {}
      } else if (ids.length === 1) {
        start = { px: e.clientX, py: e.clientY, x: Z.x, y: Z.y, moved: false };
        if (Z.s > 1) { img.style.transition = 'none'; try { img.setPointerCapture(e.pointerId); } catch (x) {} }
      }
    });
    img.addEventListener('pointermove', function (e) {
      if (!Z) return;
      if (e.pointerType === 'mouse' && !e.buttons) {
        /* desktop: once zoomed, the image follows the pointer */
        if (Z.s > 1 && Z.img === img) { var f = img.parentNode.getBoundingClientRect(), w = img.offsetWidth * Z.s, h = img.offsetHeight * Z.s; Z.x = -((e.clientX - f.left) / f.width - .5) * Math.max(0, w - f.width); Z.y = -((e.clientY - f.top) / f.height - .5) * Math.max(0, h - f.height); img.style.transition = 'none'; apply(img); }
        return;
      }
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 2 && start && start.pinch) {
        e.preventDefault();
        var a = pts[ids[0]], b = pts[ids[1]], d = Math.hypot(a.x - b.x, a.y - b.y);
        var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
        Z.s = start.s; Z.x = start.x; Z.y = start.y;
        zoomAt(img, start.s * d / (start.d || 1), start.mx, start.my);
        Z.x += mx - start.mx; Z.y += my - start.my; clamp(img); apply(img);
      } else if (ids.length === 1 && start && Z.s > 1) {
        e.preventDefault();
        Z.x = start.x + e.clientX - start.px; Z.y = start.y + e.clientY - start.py; start.moved = true; clamp(img); apply(img);
      } else if (start && Math.hypot(e.clientX - start.px, e.clientY - start.py) > 10) start.moved = true;
    });
    function up(e) {
      if (!pts[e.pointerId]) return;
      delete pts[e.pointerId];
      img.style.transition = 'transform .25s ease';
      if (start && start.pinch) { if (Object.keys(pts).length === 0) { start = null; if (Z && Z.s < 1.08) reset(); } return; }
      if (!Z || !start || start.moved || e.type === 'pointercancel') { start = null; return; }
      if (e.pointerType === 'mouse') { if (Z.s > 1) reset(); else zoomAt(img, 2.5, e.clientX, e.clientY); }
      else { var now = Date.now(); if (now - lastTap < 320) { lastTap = 0; if (Z.s > 1) reset(); else zoomAt(img, 2.5, e.clientX, e.clientY); } else lastTap = now; }
      start = null;
    }
    img.addEventListener('pointerup', up); img.addEventListener('pointercancel', up);
  }

  var q = 0;
  function go() { all(); if (window.MutationObserver) new MutationObserver(function () { if (q) return; q = setTimeout(function () { q = 0; all(); }, 150); }).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
  window.addEventListener('load', all);
  window.addEventListener('resize', all);
})();

/* The next stage (23 Oct 2026): the stacked stage chips on these tiles become one progress line across the top of the tile, 4 segments, lit for the stages the product covers, with the number and name beneath each lit segment. Pictures sit centred beneath it (CSS in sg-palette-b.css, block 12). */
(function () {
  function up(t) {
    if (t.classList.contains('t-line')) return;
    var on = {};
    [].forEach.call(t.querySelectorAll('.l1'), function (l) {
      var n = l.querySelector('.n'), s = l.querySelector('.s'), k = parseInt(n ? n.textContent : '', 10);
      if (k >= 1 && k <= 4) on[k] = { n: n.textContent.trim(), s: s ? s.textContent.trim() : '' };
    });
    if (!Object.keys(on).length) return;
    var frag = document.createDocumentFragment();
    for (var i = 1; i <= 4; i++) {
      var st = document.createElement('span'); st.className = 'tsg' + (on[i] ? ' on' : '');
      if (on[i]) {
        var n = document.createElement('span'); n.className = 'n'; n.textContent = on[i].n; st.appendChild(n);
        var s = document.createElement('span'); s.className = 's'; s.textContent = on[i].s; st.appendChild(s);
      }
      frag.appendChild(st);
    }
    t.textContent = ''; t.appendChild(frag); t.classList.add('t-line');
  }
  function run() { [].forEach.call(document.querySelectorAll('.nx-tile .t-idx'), up); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () { if (pending) return; pending = true; (window.requestAnimationFrame || setTimeout)(function () { pending = false; run(); }); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* in-page anchors (26 Oct). Every #link lands its target just under the sticky menu, and lands it again once images, fonts and accordions have settled, so FAQ, Status and PDP links never end up in the next section */
(function () {
  'use strict';
  var moved = false;
  ['wheel', 'touchmove', 'keydown'].forEach(function (t) { window.addEventListener(t, function () { moved = true; }, { passive: true }); });
  /* the menu plus any bar stuck under it (the FAQ chips and search, page jump bars) */
  function off() {
    var h = document.querySelector('.sg-hdr-sec'), b = h ? h.offsetHeight : 0, lim = window.innerHeight * 0.45;
    Array.prototype.forEach.call(document.querySelectorAll('body *'), function (el) {
      var cs = getComputedStyle(el); if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect(); if (!r.height || r.width < window.innerWidth * 0.5 || r.bottom > lim) return;
      var t = parseFloat(cs.top); if (isNaN(t) || r.top > t + 2) return;
      b = Math.max(b, r.bottom);
    });
    return b + 20;
  }
  function find(hash) {
    if (!hash || hash.length < 2) return null;
    var id = hash.slice(1); try { id = decodeURIComponent(id); } catch (e) {}
    var el = document.getElementById(id);
    if (!el || !el.getClientRects().length) return null;
    return el;
  }
  function go(el, smooth) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - off();
    window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: smooth ? 'smooth' : 'auto' });
  }
  function settle(el) {
    var n = 0;
    (function again() { if (moved || !el.isConnected) return; go(el, false); if (++n < 7) setTimeout(again, n < 3 ? 160 : 420); })();
  }
  function start() { var el = find(location.hash); if (el) { moved = false; settle(el); } }
  if (location.hash) {
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { var el = find(location.hash); if (el && !moved) go(el, false); });
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]'); if (!a || a.target === '_blank') return;
    var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
    if (u.origin !== location.origin || u.pathname !== location.pathname || !u.hash || u.hash === '#') return;
    var el = find(u.hash); if (!el) return;
    e.preventDefault();
    if (history.pushState) history.pushState(null, '', u.hash);
    moved = false; go(el, true);
    setTimeout(function () { if (!moved) go(el, false); }, 750);
  });
})();

/* stage formulation panels (26 Oct, Mat). A product's science copy (Purpose, Scientific explanation, Key actives, Support actives, How to use) is grouped
   by heading so each part reads as its own section: the first list becomes a soft panel, the second an outlined one, the closing usage notes sit under a rule.
   Worked out from the structure, not the words, so it holds in every language */
(function () {
  'use strict';
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg-split-t > .pg-rte:not([data-sg-stg])'), function (rte) {
      var hs = rte.querySelectorAll(':scope > h3'), uls = rte.querySelectorAll(':scope > ul');
      if (hs.length < 4 || uls.length < 2) return;
      rte.setAttribute('data-sg-stg', '1'); rte.classList.add('sg-stg');
      var kids = Array.prototype.slice.call(rte.childNodes), groups = [], cur = null;
      kids.forEach(function (n) {
        if (n.nodeType === 1 && n.tagName === 'H3') { cur = document.createElement('div'); cur.className = 'sg-stg-s'; groups.push(cur); rte.insertBefore(cur, n); }
        if (cur) cur.appendChild(n);
      });
      var lists = groups.filter(function (g) { return g.querySelector(':scope > ul'); });
      if (lists[0]) lists[0].classList.add('sg-stg-s--key');
      if (lists[1]) lists[1].classList.add('sg-stg-s--sup');
      var last = groups[groups.length - 1];
      if (last && !last.querySelector(':scope > ul')) last.classList.add('sg-stg-s--use');
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
/* Inner Circle signup (26 Oct, Mat): the footer form sends in place, so the page never jumps, and the confirmation replaces the field where it stood. Shopify's spam check still runs first, then hands the form back through form.submit(), which lands here */
(function(){
  if (!window.fetch || !window.FormData) return;
  var f = document.getElementById('sg-nl'); if (!f || f.tagName !== 'FORM' || !f.querySelector('input[type="email"]')) return;
  var nat = HTMLFormElement.prototype.submit;
  var send = function () {
    if (f.classList.contains('is-busy')) return;
    f.classList.add('is-busy');
    var b = f.querySelector('button'); if (b) b.setAttribute('aria-busy', 'true');
    var fallback = function () { f.classList.remove('is-busy'); nat.call(f); };
    fetch(f.action, { method: 'POST', body: new FormData(f), credentials: 'same-origin' }).then(function (r) {
      return r.text().then(function (t) { return { u: r.url || '', t: t, ok: r.ok }; });
    }).then(function (x) {
      if (/\/challenge/.test(x.u) || !x.ok) return fallback();
      if (!(/customer_posted=true/.test(x.u) || /class="nl-ok/.test(x.t))) return fallback();
      var h = f.offsetHeight;
      var p = document.createElement('p'); p.className = 'nl-ok nl-ok--in'; p.setAttribute('role', 'status'); p.tabIndex = -1;
      p.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span></span>';
      p.lastChild.textContent = f.getAttribute('data-ok') || 'Thank you for joining.';
      f.style.minHeight = h + 'px'; f.innerHTML = ''; f.appendChild(p);
      f.classList.remove('is-busy'); f.classList.add('is-done');
      try { p.focus({ preventScroll: true }); } catch (err) {}
    }).catch(fallback);
  };
  f.submit = send;
  f.addEventListener('submit', function (e) {
    if (f.checkValidity && !f.checkValidity()) return;
    if (e.defaultPrevented || f.hasAttribute('data-cptcha')) return;
    e.preventDefault(); send();
  });
})();

/* swipe cue for chip and jump menus that run off the screen (care guide, FAQs, product information, Academy, ICONICA,
   Featured Artists, Hall of Fame, legends, styles, symbols, studio tabs). The row fades out at the edge that has more to
   show, and the first time it scrolls into view it eases a little way left and back, so it reads as something to swipe.
   Rows only, product rails keep their own layout (28 Oct 2026) */
(function () {
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function edges(el) {
    var max = el.scrollWidth - el.clientWidth;
    el.classList.toggle('sg-hs-l', el.scrollLeft > 4);
    el.classList.toggle('sg-hs-end', el.scrollLeft >= max - 4);
  }
  function nudge(el) {
    if (still || el.__sgNudged || el.scrollLeft > 4) return;
    el.__sgNudged = 1;
    var go = Math.min(64, el.scrollWidth - el.clientWidth);
    try { el.scrollTo({ left: go, behavior: 'smooth' }); } catch (e) { el.scrollLeft = go; }
    setTimeout(function () { if (el.scrollLeft <= go + 2) { try { el.scrollTo({ left: 0, behavior: 'smooth' }); } catch (e) { el.scrollLeft = 0; } } }, 650);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.9) { io.unobserve(e.target); setTimeout(function () { nudge(e.target); }, 350); } });
  }, { threshold: [0.9] }) : null;
  function arm(el) {
    if (el.__sgHs) { edges(el); return; }
    el.__sgHs = 1;
    el.classList.add('sg-hs');
    edges(el);
    el.addEventListener('scroll', function () { edges(el); }, { passive: true });
    /* keep the chosen chip in view */
    var on = el.querySelector('[aria-current="true"],[aria-pressed="true"],[aria-selected="true"],.on,.is-active,.active');
    if (on && on.offsetLeft + on.offsetWidth > el.clientWidth) el.scrollLeft = on.offsetLeft - 20;
    if (io) io.observe(el);
  }
  function scan() {
    var all = document.body ? document.body.querySelectorAll('nav,div,ul,ol') : [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (!el.clientWidth || el.clientHeight > 140) continue;
      var ox = getComputedStyle(el).overflowX;
      if (ox !== 'auto' && ox !== 'scroll') continue;
      if (el.scrollWidth <= el.clientWidth + 4) { if (el.__sgHs) el.classList.add('sg-hs-end'); continue; }
      if (el.querySelectorAll('a,button,label').length < 2) continue;
      arm(el);
    }
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(scan, 200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon); else soon();
  window.addEventListener('load', function () { scan(); setTimeout(scan, 1500); });
  window.addEventListener('resize', soon);
})();

/* product page "4.8 · 9 reviews" link: land on the reviews heading below the sticky header, and settle again once the
   reviews app has finished drawing, instead of stopping under the header (28 Oct 2026) */
(function () {
  function hdrBottom() {
    var h = 0;
    [].forEach.call(document.querySelectorAll('.sg-hdr, header, .sg-ann, .announcement-bar'), function (el) {
      var cs = getComputedStyle(el); if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect(); if (r.bottom > h && r.top < 40) h = r.bottom;
    });
    return h || 80;
  }
  function go(t, smooth) {
    var y = t.getBoundingClientRect().top + window.pageYOffset - hdrBottom() - 24;
    try { window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { window.scrollTo(0, y); }
  }
  function land(t) { go(t, true); setTimeout(function () { go(t, false); }, 900); setTimeout(function () { go(t, false); }, 2000); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#reviews"], a[href$="#reviews"]');
    if (!a) return;
    var t = document.getElementById('reviews'); if (!t) return;
    var u = a.getAttribute('href'); if (u.charAt(0) !== '#' && u.split('#')[0] && u.split('#')[0] !== location.pathname) return;
    e.preventDefault(); land(t);
    if (history.replaceState) history.replaceState(null, '', '#reviews');
  });
  if (location.hash === '#reviews') window.addEventListener('load', function () { var t = document.getElementById('reviews'); if (t) setTimeout(function () { land(t); }, 300); });
})();

/* Hall of Fame search on phones: a placeholder short enough to read in full (28 Oct 2026) */
(function () {
  function fit() { var i = document.querySelector('.sghof .hof-q input'); if (!i) return; if (!i.__sgPh) i.__sgPh = i.getAttribute('placeholder') || ''; i.setAttribute('placeholder', window.innerWidth < 750 ? (document.documentElement.lang && document.documentElement.lang.slice(0, 2) !== 'en' ? i.__sgPh : 'Search artist or title') : i.__sgPh); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('resize', fit);
})();

/* typed tick and cross characters in page copy (Claims and compliance, the aftercare comparison table) are drawn with the
   site's own fine tick and cross, the same marks as "Do this instead" in the care guides (28 Oct 2026) */
(function () {
  var RX = /[✔✓✅✘✗❌]/;
  function run() {
    var root = document.querySelector('main') || document.body; if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) { return RX.test(n.nodeValue) && !(n.parentNode.closest && n.parentNode.closest('script,style,textarea,input,.sg-tk')) ? 1 : 2; } });
    var list = []; while (w.nextNode()) list.push(w.currentNode);
    list.forEach(function (n) {
      var parts = n.nodeValue.split(/([✔✓✅✘✗❌])️?\s*/), f = document.createDocumentFragment();
      parts.forEach(function (p) {
        if (!p) return;
        if (/^[✔✓✅]$/.test(p)) { var i = document.createElement('i'); i.className = 'sg-tk'; i.setAttribute('aria-hidden', 'true'); f.appendChild(i); }
        else if (/^[✘✗❌]$/.test(p)) { var x = document.createElement('i'); x.className = 'sg-tk sg-tk--x'; x.setAttribute('aria-hidden', 'true'); f.appendChild(x); }
        else f.appendChild(document.createTextNode(p));
      });
      n.parentNode.replaceChild(f, n);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function () { setTimeout(run, 600); });
})();

/* Signature Studios Australia: the search box and the state and style filters fold away behind one
   "Search and filter studios" button, on phones and desktop. Opens on its own when a search or filter is already set (28 Oct 2026) */
(function () {
  function run() {
    var tools = document.getElementById('sgl-find'); if (!tools || tools.querySelector('.sgl-tg')) return;
    var wrap = tools.querySelector('.sgl-wrap'), search = document.getElementById('sgl-search'), filters = tools.querySelector('.sgl-filters');
    if (!wrap || !search || !filters) return;
    var lang = (document.documentElement.lang || 'en').toLowerCase();
    var T = { fr: 'Rechercher et filtrer les studios', de: 'Studios suchen und filtern', es: 'Buscar y filtrar estudios', ja: 'スタジオを検索・絞り込み', ko: '스튜디오 검색 및 필터', 'zh-tw': '搜尋與篩選工作室' };
    var txt = T[lang] || T[lang.split('-')[0]] || 'Search and filter studios';
    var label = search.querySelector('.sgl-label');
    if (label) { label.classList.add('sgl-label--out'); wrap.insertBefore(label, search); }
    var panel = document.createElement('div'); panel.className = 'sgl-panel'; panel.id = 'sgl-panel';
    wrap.insertBefore(panel, search); panel.appendChild(search); panel.appendChild(filters);
    var b = document.createElement('button'); b.type = 'button'; b.className = 'sgl-tg'; b.setAttribute('aria-controls', 'sgl-panel'); b.setAttribute('aria-expanded', 'false');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.4 15.4l4.6 4.6"/></svg><span></span><i aria-hidden="true"></i>';
    b.querySelector('span').textContent = txt;
    wrap.insertBefore(b, panel);
    function set(open, focus) {
      tools.classList.toggle('sgl-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && focus && window.matchMedia('(hover:hover)').matches) { var q = document.getElementById('sgl-q'); if (q) setTimeout(function () { q.focus({ preventScroll: true }); }, 60); }
    }
    b.addEventListener('click', function () { set(!tools.classList.contains('sgl-open'), true); });
    var q = document.getElementById('sgl-q');
    var active = (q && q.value) || tools.querySelector('.sgl-filter [aria-pressed="true"]:not(:first-of-type)');
    set(!!active, false);
    var reset = document.getElementById('sgl-reset'); if (reset) reset.addEventListener('click', function () { set(false, false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function () { setTimeout(run, 300); });
})();
